import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <nav className="border-b border-border/50 backdrop-blur-sm sticky top-0 z-40 bg-background/80">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
          <Link to="/" aria-label="Home"><Logo variant="full" className="h-12 sm:h-14 object-contain" /></Link>
          <Link to="/pricing"><Button variant="ghost" size="sm">Pricing</Button></Link>
        </div>
      </nav>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-invert prose-headings:font-display prose-headings:font-bold prose-h1:text-4xl prose-h2:text-2xl prose-h2:mt-10 prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary">
        <h1>Privacy Notice</h1>
        <p className="text-sm">Last updated: April 28, 2026</p>

        <h2>Who we are</h2>
        <p>
          <strong>Pull Over Sales</strong> ("we", "us", "our") provides the Pull Over Sales sales
          activity tracking service. We act as the <strong>data controller</strong> for the personal
          data you and your dealership provide while using the Service.
        </p>

        <h2>What we collect</h2>
        <ul>
          <li><strong>Account data:</strong> name, email, password hash, dealership, role.</li>
          <li><strong>Service content:</strong> deals, activities, next steps, customer names/emails/phone you enter, customer feedback (CSI) ratings and notes.</li>
          <li><strong>Usage / telemetry:</strong> events you trigger in-app (e.g. logged activity, viewed leaderboard), used to improve the product and surface dealership health metrics.</li>
          <li><strong>Device data:</strong> IP address, user agent, push subscription endpoints (if you enable notifications).</li>
          <li><strong>Support communications:</strong> messages you send us.</li>
        </ul>

        <h2>Why we use it</h2>
        <ul>
          <li>To provide the Service (contract performance).</li>
          <li>To send the push notifications you opt into (consent).</li>
          <li>To prevent abuse, fraud, and secure the Service (legitimate interest).</li>
          <li>To improve the product and provide aggregate dealership-health analytics (legitimate interest).</li>
          <li>To respond to your support requests (legitimate interest).</li>
          <li>To meet legal obligations (legal obligation).</li>
        </ul>

        <h2>Who we share it with</h2>
        <ul>
          <li><strong>Paddle.com</strong> — our Merchant of Record. Paddle handles checkout, payments, subscription management, tax, invoicing, and refunds. Payment data is collected directly by Paddle; we do not see your card details.</li>
          <li><strong>Hosting & infrastructure providers</strong> — Supabase (database, auth, file storage, edge functions), web push gateway providers (for delivering notifications).</li>
          <li><strong>Email delivery</strong> — for account, transactional, and digest emails.</li>
          <li><strong>Authorities</strong> — only where required by law.</li>
        </ul>

        <h2>How long we keep it</h2>
        <p>
          Account and Service data are retained while your account is active. After cancellation, we
          keep data for up to 90 days so you can re-activate, then delete or anonymise it. Telemetry
          and aggregate analytics may be retained longer in anonymised form.
        </p>

        <h2>Your rights</h2>
        <p>
          You can access, correct, export, or delete your personal data at any time. Email us and
          we'll respond within 30 days. If you're in the UK or EEA, you also have the right to
          object, restrict processing, withdraw consent, and lodge a complaint with your supervisory
          authority.
        </p>

        <h2>International transfers</h2>
        <p>
          Pull Over Sales is operated from Canada and our service providers may process data in
          Canada, the United States, and the EU. Where data is transferred outside your jurisdiction,
          we rely on appropriate safeguards such as Standard Contractual Clauses or adequacy
          decisions.
        </p>

        <h2>Security</h2>
        <p>
          We use industry-standard encryption in transit and at rest, role-based access controls,
          and Row-Level Security on all customer data. Only the user (and the user's dealership
          managers, where appropriate) can read their data.
        </p>

        <h2>Cookies</h2>
        <p>
          We use only essential cookies required for sign-in and session management. We do not use
          advertising or cross-site tracking cookies.
        </p>

        <h2>Contact</h2>
        <p>Questions about this notice or your data? Email support and we'll respond.</p>
      </article>
    </div>
  );
}